import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsCardFilterBlock = _resolveComponent("DashboardsCardFilterBlock")!

  return (_openBlock(), _createBlock(_component_DashboardsCardFilterBlock, {
    filter: _ctx.filter,
    selectConfig: _ctx.getSelectConfig,
    isExportProgress: _ctx.isExportProgress,
    onChangeFilter: _ctx.changeFilter,
    onDownloadPDF: _ctx.downloadPDF,
    onDownloadPptx: _ctx.downloadPptx
  }, null, 8, ["filter", "selectConfig", "isExportProgress", "onChangeFilter", "onDownloadPDF", "onDownloadPptx"]))
}